export const relatorio_frota_tipo = [
  {
    id: 1,
    name: "Regular"
  },
  {
    id: 2,
    name: "Complementar"
  }
];
